export const NO_MATCH = 0;
export const DEFAULT_MATCH = 1;
export const POSITIVE_MATCH = 2;
export const NEGATIVE_MATCH = 3;

export type NodeConditionOptions = {
  skipDecoratorsCondition?: boolean;
};
